import {alt} from 'epic-react-common';
import generateWithAsyncActions from 'epic-alt-utils';

export default generateWithAsyncActions(alt, [
    'bingSearch'
], []);
